<template>
	<div class="container">
		<div class="title">
			<div>
				{{detail.title}}
			</div>
			<div class="newsMsg">
				<div style="font-size: 14px;"> {{detail.author}}</div>
				<div class="date">{{detail.timestamp}}</div>
			</div>
		</div>
		<div class="detail" v-html="detail.content"></div>
	</div>
</template>

<script>
	export default {
		name: 'NewsDetail',
		data() {
			return {
				content: '',
				detail: {}
			}
		},
		methods: {
			getData() {
				// this.$api.news.getMember().then((res) => {})
			}
		},
		created() {
			let userLanguage = localStorage.getItem('userLanguage')
			this.detail =   JSON.parse(localStorage.getItem('inputData'))
			console.log(this.detail)
			if (userLanguage == 'en') {
				this.detail.content = this.detail.content_en
				this.detail.title = this.detail.title_en
				this.detail.author = this.detail.author_en
			}
			
		}
	}
</script>

<style scoped>
	.container {
		width: 80%;
		padding: 2% 13%;
		margin: 0 auto;
		box-sizing: border-box;
	}

	.title {
		font-size: 28px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 57.6px;
		color: rgba(29, 33, 48, 1);
		vertical-align: top;

	}

	.date {
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 24px;
		margin-left: 50px;
	}

	.detail {
		padding: 2% 0;
	}

	.newsMsg {
		display: flex;
		text-align: right;
		align-items: center;
		justify-content: end;
	}
</style>